export default __webpack_public_path__ + "static/media/emoji-camera.10036d58.svg";